module.exports = __webpack_public_path__ + "static/media/pyv-edit-delete-select-pyv-click-save-and-exit.5ffa2598.gif";